<template>
  <div class="negocio__velo negocio__velo--encima" @click.self="$emit('cerrar')">
    <form class="negocio__modal envio" :class="{ 'envio--ancho': nivel === 'info3' }" @submit.prevent="enviar">
      <header class="negocio__modal-cabecera negocio__modal-cabecera--azul">
        <h2>✉️ Enviar {{ nivel === 'info3' ? 'INFO 3 (Expediente Completo)' : 'INFO 1 (Ficha Básica)' }} · {{ nombre }}</h2>
        <button class="negocio__cerrar" type="button" @click="$emit('cerrar')">&times;</button>
      </header>

      <div class="negocio__modal-cuerpo negocio__formulario">
        <p v-if="error" class="negocio__aviso negocio__aviso--error">{{ error }}</p>
        <p v-if="!datos && !error" class="negocio__aviso">Cargando…</p>

        <template v-if="datos">
          <div class="envio__niveles">
            <p class="envio__titulo">Nivel de Información a Enviar:</p>
            <label class="envio__nivel" :class="{ 'envio__nivel--activo': nivel === 'info1' }">
              <input v-model="nivel" type="radio" value="info1" @change="cargarBorrador">
              <span>
                <strong>INFO 1 (Ficha Básica)</strong>
                <small>Datos públicos del terreno y botón «Solicitar más información» · Pasa a Borde Amarillo</small>
              </span>
            </label>
            <label class="envio__nivel" :class="{ 'envio__nivel--activo': nivel === 'info3', 'envio__nivel--bloqueado': !datos.ovi }">
              <input v-model="nivel" type="radio" value="info3" :disabled="!datos.ovi" @change="cargarBorrador">
              <span>
                <strong>INFO 3 (Expediente Completo)</strong>
                <small v-if="datos.ovi">Carpeta técnica y legal con los documentos · Pasa a Amarillo Entero</small>
                <small v-else>Se libera cuando el cliente pide más información (OVI)</small>
              </span>
            </label>
          </div>

          <div class="envio__columnas">
            <div class="envio__columna">
              <div>
                <p class="envio__titulo">Contactos Destinatarios en {{ cliente }}:</p>
                <div class="envio__contactos">
                  <p v-if="!datos.contactos.length" class="negocio__tenue">
                    El cliente no tiene contactos. Agrégalos en el admin, en la ficha del cliente.
                  </p>
                  <label v-for="c in datos.contactos" :key="c.id" class="envio__contacto" :class="{ 'envio__contacto--sin': !c.email }">
                    <input v-model="contactos" type="checkbox" :value="c.id" :disabled="!c.email">
                    <span>{{ c.nombre }}{{ c.tipo ? ` - ${c.tipo}` : '' }} <em>({{ c.email || 'sin correo' }})</em></span>
                  </label>
                </div>
              </div>
              <label><span>Asunto:</span><input v-model="asunto" required></label>
              <label>
                <span>{{ nivel === 'info3' ? 'Cuerpo del Mensaje (Envío INFO 3):' : 'Ficha Ejecutiva (Envío INFO 1):' }}</span>
                <textarea v-model="mensaje" rows="9" required class="envio__mensaje"></textarea>
              </label>
              <p class="envio__nota">
                El saludo «Estimado(a) [Nombre]» y tu firma se agregan solos.
                <template v-if="nivel === 'info1'">El correo lleva el botón «Solicitar más información»: cuando el cliente lo usa, se acepta la OVI.</template>
              </p>
              <div class="envio__remitente">
                <span>Correo saliente:</span>
                <strong>{{ datos.remitente || 'Falta DEFAULT_FROM_EMAIL en el servidor' }}</strong>
              </div>
            </div>

            <div v-if="nivel === 'info3'" class="envio__expediente">
              <header>
                <span>📁 Documentación Adjunta ({{ adjuntos.length }})</span>
                <nav>
                  <button
                    v-for="a in areas"
                    :key="a.id"
                    type="button"
                    :class="{ 'envio__area--activa': area === a.id }"
                    @click="area = a.id"
                  >{{ a.nombre }}</button>
                </nav>
              </header>
              <div class="envio__docs">
                <p v-if="!delArea.length" class="negocio__tenue">No hay documentos subidos en esta área.</p>
                <div v-for="d in delArea" :key="d.id" class="envio__doc">
                  <label>
                    <input v-model="adjuntos" type="checkbox" :value="d.id">
                    <span>{{ d.nombre }}</span>
                  </label>
                  <a :href="d.url" target="_blank" rel="noopener" title="Ver documento">👁️</a>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="negocio__pie">
          <button class="negocio__boton negocio__boton--gris" type="button" @click="$emit('cerrar')">Cancelar y Volver</button>
          <button class="negocio__boton" type="submit" :disabled="!datos || ocupado || !contactos.length">
            {{ ocupado ? 'Enviando…' : nivel === 'info3' ? '🚀 Despachar INFO 3' : '🚀 Despachar INFO 1' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mensajeError, negocioEnviar, negocioEnvios } from '../../services/comandoApi';

// El despacho de INFO a los contactos del cliente. Lo que se manda y lo que hace
// cada destinatario queda en el informe de envíos, no en la bitácora.
export default {
  name: 'EnvioInfo',

  props: {
    unidad: { type: Number, required: true },
    nombre: { type: String, required: true },
    cliente: { type: String, required: true },
    areas: { type: Array, required: true },
  },

  emits: ['cerrar', 'enviado'],

  data() {
    return {
      datos: null,
      nivel: 'info1',
      contactos: [],
      adjuntos: [],
      asunto: '',
      mensaje: '',
      area: this.areas.length ? this.areas[0].id : null,
      error: '',
      ocupado: false,
    };
  },

  computed: {
    delArea() {
      return this.datos ? this.datos.adjuntables.filter((d) => d.area === this.area) : [];
    },
  },

  async mounted() {
    try {
      this.datos = await negocioEnvios(this.unidad);
      // Con la OVI aceptada lo que sigue es la INFO 3; antes, la INFO 1.
      this.nivel = this.datos.ovi ? 'info3' : 'info1';
      this.contactos = this.datos.contactos.filter((c) => c.email).map((c) => c.id);
      this.adjuntos = this.datos.adjuntables.map((d) => d.id);
      this.cargarBorrador();
    } catch (e) {
      this.error = mensajeError(e);
    }
  },

  methods: {
    cargarBorrador() {
      ({ asunto: this.asunto, mensaje: this.mensaje } = this.datos.borradores[this.nivel]);
    },

    async enviar() {
      this.ocupado = true;
      this.error = '';
      try {
        const respuesta = await negocioEnviar(this.unidad, {
          nivel: this.nivel,
          asunto: this.asunto,
          mensaje: this.mensaje,
          contactos: this.contactos,
          adjuntos: this.nivel === 'info3' ? this.adjuntos : [],
        });
        this.$emit('enviado', respuesta);
      } catch (e) {
        this.error = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },
  },
};
</script>
